import React from 'react'
import { gql, useQuery } from '@apollo/client'
import { DateTime } from 'luxon'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import LinearProgress from '@material-ui/core/LinearProgress'
import { isEmpty } from 'lodash'
import { GET_COACH_AVAILABILITY_OVERRIDES } from './queries'
import CustomAvailabilityFormDialog from './custom-availability-form-dialog'
import CustomAvailabilityList from './custom-availability-list'

const GET_FACILITIES = gql`
  query CoachAvailabilityFacilities {
    coachAvailabilities {
      coachFacility {
        id
        name
      }
    }
  }
`

const CustomAvailabilityManager = () => {
  const { data: facilitiesData, loading: facilitiesLoading } = useQuery(
    GET_FACILITIES,
  )
  const { data: overridesData, loading: overridesLoading, refetch } = useQuery(
    GET_COACH_AVAILABILITY_OVERRIDES,
    {
      variables: {
        dateRange: { from: DateTime.local().toISODate() },
      },
    },
  )

  const loading = facilitiesLoading || overridesLoading

  if (loading) {
    return (
      <>
        <Grid container item xs={12}>
          <Typography variant="h6">Custom Availability</Typography>
        </Grid>
        <Grid container item md={8} xs={12}>
          <Box mb={4}>
            <Typography variant="body1" color="textSecondary">
              Add one-off availability to specific dates.
            </Typography>
          </Box>
        </Grid>
        <Box p={2} width="100%">
          <LinearProgress />
        </Box>
      </>
    )
  }

  if (isEmpty(facilitiesData?.coachAvailabilities)) {
    return null
  }

  const facilities = Array.from(
    new Map(
      facilitiesData.coachAvailabilities.map(a => [
        a.coachFacility.id,
        a.coachFacility,
      ]),
    ).values(),
  )
  const overrides = overridesData?.coachAvailabilityOverrides || []

  return (
    <>
      <Grid container item xs={12}>
        <Typography variant="h6">Custom Availability</Typography>
      </Grid>
      <Grid container item xs={12} md={8}>
        <Box mb={4}>
          <Typography variant="body1" color="textSecondary">
            Add one-off availability to specific dates. Supplement your
            recurring schedule with additional time slots at your chosen
            facility.
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box mb={2}>
          <CustomAvailabilityFormDialog
            facilities={facilities}
            onSuccess={refetch}
          />
        </Box>
        <CustomAvailabilityList overrides={overrides} refetch={refetch} />
      </Grid>
    </>
  )
}

export default CustomAvailabilityManager
